// check if current path is /auth/*
export const isAuthPage = ({ route }) => {
    if( route.path.indexOf('/auth') !== -1)
        return true;
    
    if( route.path.indexOf('/login') !== -1)
        return true;
    
    if( route.path.indexOf('/secure-login') !== -1)
        return true;

    if( route.path.indexOf('/register') !== -1)
        return true;

    if( route.path.indexOf('/reset/') !== -1)
        return true;

    if( route.path.indexOf('/verification') !== -1)
        return true;
    
    if( route.path.indexOf('/installApp') !== -1)
        return true;

    if( route.path.indexOf('/notAllowed') !== -1)
        return true;
    
    if( route.path.indexOf('/apiaccess') !== -1)
        return true;

    if( route.path.indexOf('/terms') !== -1)
        return true;

    if( route.path.indexOf('/privacy') !== -1)
        return true;
    if( route.path.indexOf('/requestinitiate') !== -1)
        return true;
    if( route.path.indexOf('/domain_authorized') !== -1)
        return true;
    if( route.path.indexOf('/signup') !== -1)
        return true;

    if (route.path.indexOf('/esareporting') !== -1)
        return true;
    if( route.path.indexOf('/support') !== -1)
        return true;
    return false;

}

// check if navigation should be displayed
// if route.path does not exist yet returns false
export const shouldShowNavigation = ({ route }, getters) => (route.path ? !getters.isAuthPage : false);




// WEBPACK FOOTER //
// ./src/store/getters.js